module.exports = __webpack_public_path__ + "img/alerta2.95c467fd.svg";